import { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import useStyles from "../styles";
import EmptyStateImg from "../../../assets/images/Empty State.png";
import { httprequest } from "../../../data/api";
import PageLoader from "../../../components/PageLoader";

const PRACTICE_SESSIONS_ENDPOINT = "/api/v1/practice-sessions";

const PracticeSection = ({ viewAll }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [inProgress, setInProgress] = useState([]);
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        setLoading(true);
        const [resInProgress, resPaused, resSummary] = await Promise.all([
          httprequest.get(`${PRACTICE_SESSIONS_ENDPOINT}?status=in_progress`),
          httprequest.get(`${PRACTICE_SESSIONS_ENDPOINT}?status=paused`),
          httprequest.get(`${PRACTICE_SESSIONS_ENDPOINT}?status=completed`)
        ]);

        const inProgressData = resInProgress?.data?.data || [];
        const pausedData = resPaused?.data?.data || [];
        setInProgress([...inProgressData, ...pausedData]);
        if (resSummary?.data?.data) {
          setSummary(resSummary.data.data);
        }
      } catch (err) {
        // console.error("Error fetching sessions", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSessions();
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <Grid container spacing={2}>
      {/* In Progress Section */}
      <Grid item lg={6} md={6} sm={12} xs={12}>
        <div className={classes.practiceOuterContainer}>
          <div className={classes.practiceHeaderFlex}>
            <div>
              <p className={classes.practiceHeaderTitle}>In progress</p>
              <p className={classes.practiceHeaderSubtitle}>
                Resume practice that has not been submitted
              </p>
            </div>
          </div>
          <div>
            {inProgress.length === 0 ? (
              <div className={classes.emptyPracticeState}>
                <img src={EmptyStateImg} alt="No Practice" />
                <p>No Practice has been taken</p>
              </div>
            ) : (
              inProgress.map((item) => {
                const filter = item.filter_json || item.filter || item;

                return (
                  <div key={item.id} className={classes.practiceCard}>
                    <div className={classes.practiceCardContent}>
                      <p className={classes.practiceCardTitle}>{filter.subject || "Practice Session"}</p>
                      <p className={classes.practiceCardSubline}>{filter.exam_type ? `${filter.exam_type} - ${filter.year || ""}` : "General"}</p>
                      <p className={classes.practiceCardSubline}>
                        Last activity: {new Date(item.updated_at || item.completed_at || item.started_at || item.created_at).toLocaleDateString()}
                      </p>
                    </div>
                    <button className={classes.practiceActionBtn} onClick={() => navigate(`/student/my-learning/practice/${item.id}`)}>Resume</button>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </Grid>

      {/* Summary / My session Section */}
      <Grid item lg={6} md={6} sm={12} xs={12}>
        <div className={classes.practiceOuterContainer}>
          <div className={classes.practiceHeaderFlex}>
            <div>
              <p className={classes.practiceHeaderTitle}>My session</p>
              <p className={classes.practiceHeaderSubtitle}>
                See the history of all Questions you've attempted
              </p>
            </div>
            {viewAll && summary.length > 0 && (
              <button
                className={classes.practiceActionBtn}
                style={{ color: "black", fontWeight: 500 }}
                onClick={() => navigate("/student/my-learning")}
              >
                View All
              </button>
            )}
          </div>
          <div>
            {summary.length === 0 ? (
              <div className={classes.emptyPracticeState}>
                <img src={EmptyStateImg} alt="No Session" />
                <p>No Session has been attempted</p>
              </div>
            ) : (
              summary.map((item) => {
                const filter = item.filter_json || item.filter || item;
                const scoreDisplay = item.score_percentage != null ? `${item.score_percentage}%` : (item.score != null ? `${item.score}%` : "--");
                const timeSpentDisplay = item.time_spent_seconds != null ? Math.ceil(item.time_spent_seconds / 60) : (item.time_spent || item.duration || 0);

                return (
                  <div key={item.id} className={classes.practiceCard}>
                    <div className={classes.practiceCardContent}>
                      <p className={classes.practiceCardTitle}>{filter.subject || "Practice Session"}</p>
                      <div className={classes.practiceCardSubtitle}>
                        <span className={classes.practiceIconText}>
                          <Icon icon="mdi:clock-outline" width="16" /> {timeSpentDisplay} mins
                        </span>
                        <span>•</span>
                        <span className={classes.practiceIconText}>
                          <Icon icon="carbon:checkmark-outline" width="16" /> {scoreDisplay}
                        </span>
                      </div>
                    </div>
                    <button className={classes.practiceActionBtn} onClick={() => navigate(`/student/my-learning/practice-review/${item.id}`)}>Review</button>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default PracticeSection;
